"use client";

import React, { useEffect, useState } from "react";
import useUserStore from "@/lib/Store/useUserStore";
import ShoppingProductCard from "../ShoppingProductCard";
// import WearthatLoader from "../../Atoms/WearthatLoader";
import { sendGTMEvent } from "@next/third-parties/google";
import { UK } from "../../../public/Constants/EnumConstants";
import { getWishListData } from "../../../lib/bigcommerce/restfull/apis/wishlistAPIS";
import { BRAND_NAMES } from "../ProductFilters/constants";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { convertIntoSelectedCurrency } from "../../utils/utils";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import useStore from "../../../lib/Store/useStore";
import {
    convertToSlug,
    formatPrice,
    showBackInStockBadge,
    sortImages,
} from "../../utils/utils.js";
import NewPrimaryButton from "@/components/Atoms/Buttons/NewPrimaryButton";
import useProductListStore from "@/lib/Store/useProductListStore";
import ProductsProgressBar from "../ProductsProgressBar";

const ProductsListScrollArea = ({
    pageInfo,
    showPaginationButtons = true,
    backendProducts,
}) => {
    const router = useRouter();
    const pathName = usePathname();
    const searchParams = useSearchParams();
    const urlParams = new URLSearchParams(searchParams);

    const { userData } = useUserStore();
    const { authSession, currency, exchangeRate } = useStore();
    const [wishListProducts, setWishListProducts] = useState(null);
    const [callServerAction, setCallServerAction] = useState(false);

    const [loading, setLoading] = useState(false);

    const {
        getPaginatedData,
        paginatedData,
        addPaginatedData,
        pageInfo: storedPageInfo,
    } = useProductListStore();

    const loadMore = async (urlParams) => {
        setLoading(true);
        urlParams.set("page", (storedPageInfo?.page || 1) + 1);
        const url = `${pathName}?${urlParams.toString()}`;
        router.replace(url, { scroll: false });
    };
    useEffect(() => {
        if (backendProducts?.length) {
            addPaginatedData(pageInfo, backendProducts);
            setLoading(false);
        }
    }, [backendProducts, pageInfo]);

    useEffect(() => {
        const getWishListItems = async () => {
            const response = await getWishListData(
                authSession?.user?.customer_id
            );
            setWishListProducts(response);
        };
        if (authSession?.user?.customer_id) getWishListItems();
    }, [callServerAction, authSession]);

    if (!getPaginatedData()?.length) {
        return (
            <div className="flex flex-col text-center h-screen mt-4 sm:mt-12">
                <TypographyMontserrat
                    customStyle=" text-xl sm:text-[28px] "
                    fontWeight="bold"
                    text={"No Results Found"}
                />
            </div>
        );
    }

    return (
        <>
            <div className="mt-3 sm:mt-5 grid grid-cols-12  gap-x-4 sm:gap-x-6 gap-y-5 sm:gap-y-10">
                {getPaginatedData()?.map((product, index) => {
                    const brandName = BRAND_NAMES?.[product?.brand_id] || "";
                    const backInStockBadge = showBackInStockBadge(
                        product?.customFields
                    );
                    const totalStockOfVariants = product?.variants?.reduce(
                        (n, { stock }) => n + stock,
                        0
                    );
                    const customFields =
                        product?.customFields || product?.custom_fields;
                    const productVideoField = customFields?.find(
                        (customField) =>
                            customField?.custom_field_name === "product_video"
                    );
                    const videoUrl =
                        productVideoField?.value ||
                        productVideoField?.custom_field_value;

                    const productId =
                        product?.variants &&
                        (product?.variants[0]?.parentId ||
                            product?.variants[0]?.product_id);

                    const isWishListItem = wishListProducts?.items?.some(
                        (item) => item?.product_id == productId
                    );

                    const itemId = wishListProducts?.items?.find(
                        (item) => item?.product_id == productId
                    );
                    const productPath = convertToSlug(product?.product_name);
                    const images = sortImages(product?.images);
                    const convertedPrice = convertIntoSelectedCurrency(
                        product?.product_price || product?.price,
                        exchangeRate
                    );
                    const salePrice = convertIntoSelectedCurrency(
                        product?.sale_price,
                        exchangeRate
                    );
                    return (
                        <ShoppingProductCard
                            cardIndex={index}
                            customerId={userData?.new_bigcommerce_id}
                            key={index}
                            itemId={itemId?.id}
                            callServerAction={setCallServerAction}
                            isWishListItem={isWishListItem}
                            link={
                                product?.custom_url?.url ||
                                product?.path ||
                                product?.handle ||
                                `/${productPath}`
                            }
                            name={
                                product?.name ||
                                product?.title ||
                                product?.product_name
                            }
                            brandName={brandName}
                            categories={product?.categories}
                            images={images}
                            videoUrl={videoUrl}
                            price={convertedPrice}
                            currencyCode={currency}
                            productId={product?.id || product?.product_id}
                            onClick={() =>
                                sendGTMEvent({
                                    event: "PLPInteractions",
                                    interaction_type: "cardclicked",
                                    interaction_item: product?.name,
                                })
                            }
                            backInStockBadge={backInStockBadge}
                            totalStockOfVariants={totalStockOfVariants}
                            variants={product?.variants}
                            sizeStandard={
                                product?.availability_description || UK
                            }
                            salesPrice={
                                salePrice > 0 && salePrice != convertedPrice
                                    ? formatPrice(salePrice, currency)
                                    : null
                            }
                        />
                    );
                })}
            </div>

            {/* <ProductsProgressBar
                viewed={getPaginatedData()?.length}
                total={storedPageInfo?.total_products || 0}
            /> */}
            {showPaginationButtons && storedPageInfo?.hasNextPage && (
                <div className="w-2xl flex justify-center items-center  mt-6">
                    <NewPrimaryButton
                        disabled={!storedPageInfo?.hasNextPage}
                        text="Load More"
                        onClick={() => {
                            loadMore(urlParams);
                            sendGTMEvent({
                                event: "PLPInteractions",
                                interaction_type: "clicked",
                                interaction_item: "NextPageButton",
                            });
                        }}
                        processing={loading}
                        className="flex !text-right justify-end"
                    />
                </div>
            )}
        </>
    );
};

export default ProductsListScrollArea;
